import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS, LOGO_URL } from "@/lib/api";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#000000] text-white relative overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 cg-halftone-white opacity-10 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div data-testid="footer-brand">
            <img
              src={LOGO_URL}
              alt="Corona Gas, HVAC & Mechanical"
              className="h-16 w-auto rounded-lg mb-4"
            />
            <p className="text-sm text-white/70 leading-relaxed mb-5">
              BC's trusted name in heating, air conditioning, and gas fitting for over 20 years.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#E50914] flex items-center justify-center transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#E50914] flex items-center justify-center transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-testid="footer-services">
            <h4 className="font-[Manrope] font-bold text-lg mb-4 flex items-center gap-2">
              <span className="w-6 h-0.5 bg-[#E50914]" /> Services
            </h4>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/#services" className="hover:text-[#FCA5A5]">Furnaces & Heating</Link></li>
              <li><Link to="/#services" className="hover:text-[#FCA5A5]">Air Conditioning</Link></li>
              <li><Link to="/#services" className="hover:text-[#FCA5A5]">Heat Pumps</Link></li>
              <li><Link to="/#services" className="hover:text-[#FCA5A5]">Gas Fitting</Link></li>
              <li><Link to="/#services" className="hover:text-[#FCA5A5]">Hot Water Systems</Link></li>
            </ul>
          </div>

          {/* Quick links */}
          <div data-testid="footer-links">
            <h4 className="font-[Manrope] font-bold text-lg mb-4 flex items-center gap-2">
              <span className="w-6 h-0.5 bg-[#E50914]" /> Quick Links
            </h4>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/#about" className="hover:text-[#FCA5A5]">About Us</Link></li>
              <li><Link to="/#gallery" className="hover:text-[#FCA5A5]">Our Work</Link></li>
              <li><Link to="/#testimonials" className="hover:text-[#FCA5A5]">Reviews</Link></li>
              <li><Link to="/blog" className="hover:text-[#FCA5A5]">Blog</Link></li>
              <li><Link to="/#contact" className="hover:text-[#FCA5A5]">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div data-testid="footer-contact">
            <h4 className="font-[Manrope] font-bold text-lg mb-4 flex items-center gap-2">
              <span className="w-6 h-0.5 bg-[#E50914]" /> Reach Us
            </h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-[#E50914] mt-0.5 flex-shrink-0" />
                <a href={BUSINESS.phoneHref} className="hover:text-[#FCA5A5]">{BUSINESS.phone}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-[#E50914] mt-0.5 flex-shrink-0" />
                <a href={BUSINESS.emailHref} className="hover:text-[#FCA5A5] break-all">{BUSINESS.email}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#E50914] mt-0.5 flex-shrink-0" />
                <span>{BUSINESS.serviceArea}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-sm text-white/60">
          <div data-testid="footer-copyright">© {year} Corona Gas HVAC &amp; Mechanical. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
